export class PendingPayment {
  billAccountNumber: string;
  pastDue?: boolean;
}

export const initialPendingPayment: PendingPayment = {
  billAccountNumber: null
};
